<template>
    <b-modal v-model="modalShow" centered hide-header-close>
        <template #modal-header>
            <div class="mx-auto">
                <h5 class="text-primary font-20 font-weight-bold">{{ isEnquiring ? 'Enquiry' : 'Contact Details' }}</h5>
            </div>
        </template>
        <div>
            <div v-if="!isEnquiring">
                <div v-if="!hasCurrentEnquiryFromMyDealership">
                    <div class="font-16">
                        <div class="el-icon-info">
                        </div>
                        Enquire about these vehicle to get direct contact details.
                    </div>
                    <div class="d-flex justify-content-center mt-3">
                        <b-button variant="primary" @click="handleEnquire">Enquire</b-button>
                    </div>
                </div>
                <div v-else>
                    <div class="font-16">
                        <div class="el-icon-info"/>
                        Your dealership has already enquired about this vehicle. See message <a class="link-class" @click="handleEnquiryInfoRedirect">here</a>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="form-group row">
                    <label class="col-sm-5 col-lg-4 col-form-label">FND-{{ vehicle.id }}</label>
                    <div class="col-sm-7 col-lg-8 align-self-center">
                        <div>
                            {{ vehicle.formattedFullVehicleName }}
                        </div>
                        <div>
                            <span class="badge badge-info m-1" v-if="vehicle.mileage">
                                <span>Mileage: </span>
                                <span>{{ vehicle.mileage | local_number }}</span>
                            </span>
                            <span class="badge badge-info m-1" v-if="data_get(vehicle, 'condition.name')">
                                <span>Condition: </span>
                                <span>{{ data_get(vehicle, 'condition.name') }}</span>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-5 col-lg-4 col-form-label">Vin:</label>
                    <div class="col-sm-7 col-lg-8 align-self-center">
                        <span>{{ vehicle.vin }}</span>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-5 col-lg-4 col-form-label">Dealer:</label>
                    <div class="col-sm-7 col-lg-8 align-self-center">
                        <span>{{ dealer }}</span>
                    </div>
                </div>
                <div>
                    <div class="form-group">
                        <label class="col-form-label">Message:</label>
                        <div>
                            <textarea :class="{ 'parsley-error' : enquiryForm.errors.has('message') }"
                                      :rows="4"
                                      class="form-control"
                                      type="text"
                                      v-model="enquiryForm.message"/>
                            <ul :class="{'filled' : enquiryForm.errors.has('message')}"
                                class="parsley-errors-list">
                                <li class="parsley-required">
                                    {{ enquiryForm.errors.get('message') }}
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-12 text-center">
                            <button :disabled="enquiryForm.busy"
                                    @click="submit"
                                    class="btn btn-primary w-md waves-effect waves-light text-uppercase"
                                    type="submit">Enquire
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer">
            <b-button @click="hide">Back</b-button>
        </div>
    </b-modal>
</template>

<script>
import {DealStatus} from "@/constants/deal-statuses";
import Deal from "@/models/deal";
import Routes from "@/constants/routes";

export default {
    components: {},
    props: {
        vehicle: {
            required: true,
            type: Object,
            default: () => {
                return {}
            }
        },
    },
    watch:{
        modalShow() {
            if (this.modalShow) {
                this.isEnquiring = false;
                this.enquiryForm.clearFields();
            }
        }
    },
    data() {
        return {
            modalShow: false,
            isEnquiring: false,
            enquiryForm: new Form(
                {
                    vehicle_id: null,
                    message: null,
                    status: DealStatus.enquiry.value,
                },
                {
                    vehicle_id: 'required',
                    message: 'required|string',
                    status: 'required|integer',
                }
            ),
        }
    },
    methods: {
        show() {
            this.modalShow = true;
        },
        hide() {
            this.modalShow = false;
        },
        handleEnquire() {
            this.isEnquiring = true;
        },
        handleEnquiryInfoRedirect() {
            const deal = this.vehicle.deals.find(deal => deal.buyer?.companies[0].id === this.$store.state.user.companies[0].id);
            this.hide();
            setTimeout(() => {
                this.$router.push({
                    name: Routes.message,
                    params: {
                        deal_id: deal.id,
                        customer_id: deal.seller_id,
                    }
                });
            }, 150);
        },
        submit() {
            this.enquiryForm.vehicle_id = this.vehicle.id;
            this.enquiryForm.validate()
                .then(() => {
                    let enquiry = new Deal(this.enquiryForm);
                    enquiry.save()
                        .then(({ data }) => {
                            this.$notify.success({
                                message: 'Enquiry has been sent.'
                            });
                            this.hide();
                            this.$router.push({
                                name: Routes.message,
                                params: {
                                    deal_id: data.id,
                                    customer_id: data.seller_id,
                                }
                            });
                        })
                });
        },
    },
    computed: {
        dealer() {
            return this.vehicle.company.name
        },
        hasCurrentEnquiryFromMyDealership() {
            return this.vehicle.deals.some(deal => deal.buyer?.companies[0].id === this.$store.state.user?.companies[0].id);
        },
    },
}
</script>
<style lang="scss" scoped>
    .link-class {
        color: #15A9F0;
        font-style: italic;
        cursor: pointer;
    }
</style>
